import { c as _c } from "react/compiler-runtime";
import { BodyLong, HelpText, HStack, Loader } from "@navikt/ds-react";
import { getFormattedDateAndTimeString, getFormattedTimeString } from "@/ui-helpers/dateAndTime";
import { isDateToday, isNotMoreThanOneHourAgo } from "@/utils/dateAndTime/dateUtils";
interface Props {
  isSavingUtkast: boolean;
  utkastSistLagretTidspunkt: string | null;
}
export default function UtkastLagringInfo(t0) {
  const $ = _c(11);
  const {
    isSavingUtkast,
    utkastSistLagretTidspunkt
  } = t0;
  if (isSavingUtkast) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <HStack gap="space-16" align="center"><BodyLong size="medium" className="text-ax-text-neutral-subtle"><span>Lagrer utkast...</span></BodyLong><Loader size="small" title="Lagrer utkast" variant="interaction" className="relative -top-px" /></HStack>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (utkastSistLagretTidspunkt) {
    let t1;
    if ($[1] !== utkastSistLagretTidspunkt) {
      t1 = isDateToday(utkastSistLagretTidspunkt);
      $[1] = utkastSistLagretTidspunkt;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    const isToday = t1;
    let t2;
    if ($[3] !== isToday || $[4] !== utkastSistLagretTidspunkt) {
      const displaySeconds = isNotMoreThanOneHourAgo(utkastSistLagretTidspunkt);
      t2 = isToday ? `kl. ${getFormattedTimeString(utkastSistLagretTidspunkt, displaySeconds)}` : getFormattedDateAndTimeString(utkastSistLagretTidspunkt, displaySeconds);
      $[3] = isToday;
      $[4] = utkastSistLagretTidspunkt;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    const sistLagretTidspunktFormatted = t2;
    let t3;
    if ($[6] !== sistLagretTidspunktFormatted) {
      t3 = <BodyLong size="medium" className="text-ax-text-neutral-subtle"><span>Utkast sist lagret {sistLagretTidspunktFormatted}</span></BodyLong>;
      $[6] = sistLagretTidspunktFormatted;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <HelpText className="relative -top-px">Dine endringer lagres som et utkast mens du skriver. Hvis du ønsker å jobbe videre med oppfølgingsplanen senere kan du velge «Avslutt og fortsett senere».</HelpText>;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t3) {
      t5 = <HStack gap="space-16" align="center">{t3}{t4}</HStack>;
      $[9] = t3;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  return null;
}